import { gql } from '@apollo/client';

export default gql`
  query publishData($subDomain: String, $pageId: String) {
    publishData(subDomain: $subDomain, pageId: $pageId)
  }
`; 